module.exports = __webpack_public_path__ + "img/js.15763c03.svg";